import { SystemStyleObject } from '@chakra-ui/theme-tools';
import { fadeIn } from '@core/components/Common/styles/animations';
import { colors } from '@waitroom/config';
import { breakpointValues } from './breakpoints';
import typography from './typography';

export const mediaMobile = `@media screen and (max-width: ${breakpointValues.xl - 1}px)`;
export const mediaDesktop = `@media screen and (min-width: ${breakpointValues.lg}px)`;

const globalStyles = {
  global: (): SystemStyleObject => ({
    'html, body, #root': {
      fontFamily: typography.fonts.body,
      color: colors.gray[900],
      display: 'block',
      minHeight: '100%',
      height: '100%',
      width: '100%',
      backgroundColor: 'white',
    },
    'html, body': {},
    '#root': {},
    'body [data-loading]:disabled': {
      opacity: '1',
    },
    '.none, a.none, a.none:hover': {
      textDecoration: 'inherit',
    },
    'a.simple': {
      textDecoration: 'inherit',
      transition: 'opacity .1s ease-in',
      _hover: { opacity: 0.85 },
    },
    'a:not(.chakra-button):not(.none):not(.simple):not(.u)': {
      textDecoration: 'underline',
    },
    'a.u': {
      textDecoration: 'inherit',
      _hover: { textDecoration: 'underline' },
    },
    '.bold': {
      fontWeight: 'bold',
    },
    'strong, .strong': {
      fontWeight: 'extrabold',
    },
    '.fade-in': {
      animation: `.3s ease-in ${fadeIn}`,
    },
    '.scroll-tr ::-webkit-scrollbar-thumb, .scroll-tr::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
    },
    '.scroll-tr ::-webkit-scrollbar, .scroll-tr::-webkit-scrollbar': {
      width: '0',
      height: '0',
    },
    [mediaDesktop]: {
      '::-webkit-scrollbar': {
        position: 'relative',
        width: '10px',
        height: '10px',
        backgroundColor: 'transparent',
        zIndex: 9999999,
      },
      '::-webkit-scrollbar-track': {
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.22)',
        backgroundColor: 'transparent',
      },
      '::-webkit-scrollbar-thumb': {
        borderRadius: '5px',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.38)',
        backgroundColor: 'rgba(0,0,0,.22)',
      },
      '.scroll-light ::-webkit-scrollbar-thumb, .scroll-light::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(255,255,255,.3)',
      },
      '.scroll-thin ::-webkit-scrollbar, .scroll-thin::-webkit-scrollbar': {
        width: '7px',
        height: '7px',
      },
      '.scroll-hidden ::-webkit-scrollbar, .scroll-hidden::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
    },
    [mediaMobile]: {
      '.chakra-modal__overlay:not(.center) .chakra-modal__content-container': {
        alignItems: 'flex-start !important', // tmp solution for vertically centered modals on mobile
      },
    },
  }),
};

export default globalStyles;
